import { useQuery } from "@tanstack/react-query";

import { getOrganizationOptions } from "@/openapi/@tanstack/react-query.gen";

export const useOrganization = ({ id }: { id: string }) => {
  return useQuery(getOrganizationOptions({ path: { org_id: id } }));
};
